export function formatCode(code: string): string {
  const dot = code.indexOf('.');
  if (dot < 0) return code;
  return code.slice(0, dot).padStart(2, '0') + code.slice(dot);
}

export function formatCents(cents: number): string {
  return new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: cents % 100 === 0 ? 0 : 2,
  }).format(cents / 100);
}

export function formatDimensions(widthInches: number | null, depthInches: number | null): string {
  if (widthInches == null && depthInches == null) return '—';
  const toFtIn = (n: number): string => {
    const ft = Math.floor(n / 12);
    const inch = n % 12;
    return inch === 0 ? `${ft}'` : `${ft}'${inch}"`;
  };
  if (widthInches != null && depthInches != null) {
    return `${toFtIn(widthInches)} × ${toFtIn(depthInches)}`;
  }
  return toFtIn((widthInches ?? depthInches)!);
}
